/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from './navigation.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../src/app/layout/navigation.component';
import * as import5 from '../../../../src/app/shared/services/auth.service';
import * as import6 from '../../../../src/app/shared/services/window-ref.service';
import * as import7 from '../../../../src/app/shared/services/user.service';
const styles_NavigationLayoutComponent:any[] = [import0.styles];
export const RenderType_NavigationLayoutComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_NavigationLayoutComponent,
  data: {}
}
);
export function View_NavigationLayoutComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),106,'div',[[
        'id',
        'nav__sidebar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'col logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['DIZZEE'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),100,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,9).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        2,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,1,{links: 1}),
    import1.ɵqud(301989888,2,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-building'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['internal'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,22).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        4,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,3,{links: 1}),
    import1.ɵqud(301989888,4,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-users'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['external'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'li',[[
        'hidden',
        ''
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),15,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,35).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        6,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,5,{links: 1}),
    import1.ɵqud(301989888,6,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-user-plus'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['add external'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),18,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),15,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,55).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        8,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,7,{links: 1}),
    import1.ɵqud(301989888,8,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-envelope'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['requests'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,74).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        10,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,9,{links: 1}),
    import1.ɵqud(301989888,10,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-wrench'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['settings'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,87).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(335872,[[
        12,
        4
      ]
    ],0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(1),
    import1.ɵdid(860160,(null as any),2,import2.RouterLinkActive,[
      import2.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,11,{links: 1}),
    import1.ɵqud(301989888,12,{linksWithHrefs: 1}),
    import1.ɵpad(1),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-question'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['help'])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'li',([] as any[]),[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.NavigationLayoutComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.authService.logout()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-sign-out'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Logout'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'main',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import2.RouterOutlet,[
      import2.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),9,'footer',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Created with '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'style',
        'color: #FB8F22;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-heart'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' from Los Angeles'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['by the Swift Team'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,10,0,'/list');
    ck(v,9,0,currVal_3);
    const currVal_4:any = ck(v,14,0,'active');
    ck(v,11,0,currVal_4);
    const currVal_7:any = ck(v,23,0,'/external');
    ck(v,22,0,currVal_7);
    const currVal_8:any = ck(v,27,0,'active');
    ck(v,24,0,currVal_8);
    const currVal_11:any = ck(v,36,0,'/new-user');
    ck(v,35,0,currVal_11);
    const currVal_12:any = ck(v,40,0,'active');
    ck(v,37,0,currVal_12);
    const currVal_15:any = ck(v,56,0,'/requests');
    ck(v,55,0,currVal_15);
    const currVal_16:any = ck(v,60,0,'active');
    ck(v,57,0,currVal_16);
    const currVal_20:any = ck(v,75,0,'/settings');
    ck(v,74,0,currVal_20);
    const currVal_21:any = ck(v,79,0,'active');
    ck(v,76,0,currVal_21);
    const currVal_24:any = ck(v,88,0,'/help');
    ck(v,87,0,currVal_24);
    const currVal_25:any = ck(v,92,0,'active');
    ck(v,89,0,currVal_25);
  },(ck,v) => {
    var co:import4.NavigationLayoutComponent = v.component;
    const currVal_0:any = (co.authService.userLoginType === 'approver');
    ck(v,7,0,currVal_0);
    const currVal_1:any = import1.ɵnov(v,9).target;
    const currVal_2:any = import1.ɵnov(v,9).href;
    ck(v,8,0,currVal_1,currVal_2);
    const currVal_5:any = import1.ɵnov(v,22).target;
    const currVal_6:any = import1.ɵnov(v,22).href;
    ck(v,21,0,currVal_5,currVal_6);
    const currVal_9:any = import1.ɵnov(v,35).target;
    const currVal_10:any = import1.ɵnov(v,35).href;
    ck(v,34,0,currVal_9,currVal_10);
    const currVal_13:any = import1.ɵnov(v,55).target;
    const currVal_14:any = import1.ɵnov(v,55).href;
    ck(v,54,0,currVal_13,currVal_14);
    const currVal_17:any = (co.authService.userLoginType === 'admin');
    ck(v,72,0,currVal_17);
    const currVal_18:any = import1.ɵnov(v,74).target;
    const currVal_19:any = import1.ɵnov(v,74).href;
    ck(v,73,0,currVal_18,currVal_19);
    const currVal_22:any = import1.ɵnov(v,87).target;
    const currVal_23:any = import1.ɵnov(v,87).href;
    ck(v,86,0,currVal_22,currVal_23);
    const currVal_26:boolean = !co.authService.loggedin;
    ck(v,99,0,currVal_26);
  });
}
function View_NavigationLayoutComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-navigation-layout',([] as any[]),(null as any),(null as any),(null as any),View_NavigationLayoutComponent_0,RenderType_NavigationLayoutComponent)),
    import1.ɵdid(57344,(null as any),0,import4.NavigationLayoutComponent,[
      import5.AuthService,
      import3.Location,
      import2.Router,
      import6.WindowRefService,
      import7.UserService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NavigationLayoutComponentNgFactory:import1.ComponentFactory<import4.NavigationLayoutComponent> = import1.ɵccf('my-navigation-layout',import4.NavigationLayoutComponent,View_NavigationLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/layout/navigation.component.ngfactory.ts